/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from './navigation.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../src/app/layout/navigation.component';
import * as import5 from '../../../../src/app/shared/services/auth.service';
import * as import6 from '../../../../src/app/shared/services/window-ref.service';
import * as import7 from '../../../../src/app/shared/services/user.service';
const styles_NavigationLayoutComponent:any[] = [import0.styles];
export const RenderType_NavigationLayoutComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_NavigationLayoutComponent,
  data: {}
}
);
export function View_NavigationLayoutComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),106,'div',[[
        'id',
        'nav__sidebar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'col logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['DIZZEE'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),100,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,9).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        2,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,1,{links: 1}),
    import1.ɵqud(301989888,2,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-building'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['internal'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,22).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        4,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,3,{links: 1}),
    import1.ɵqud(301989888,4,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-users'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['external'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'li',[[
        'hidden',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),15,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,35).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        6,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,5,{links: 1}),
    import1.ɵqud(301989888,6,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-user-plus'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['add external'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),18,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),15,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,55).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        8,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,7,{links: 1}),
    import1.ɵqud(301989888,8,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-envelope'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['requests'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,74).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        10,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,9,{links: 1}),
    import1.ɵqud(301989888,10,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-wrench'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['settings'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,87).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        12,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,11,{links: 1}),
    import1.ɵqud(301989888,12,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-question'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['help'])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.NavigationLayoutComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.authService.logout()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-sign-out'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Logout'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'main',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import2.RouterOutlet,[
      import2.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),9,'footer',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Created with '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'style',
        'color: #FB8F22;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-heart'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' from Los Angeles'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['by the Swift Team'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,10,0,'/list');
    ck(v,9,0,currVal_3);
    const currVal_4:any = ck(v,14,0,'active');
    ck(v,11,0,currVal_4);
    const currVal_7:any = ck(v,23,0,'/external');
    ck(v,22,0,currVal_7);
    const currVal_8:any = ck(v,27,0,'active');
    ck(v,24,0,currVal_8);
    const currVal_11:any = ck(v,36,0,'/new-user');
    ck(v,35,0,currVal_11);
    const currVal_12:any = ck(v,40,0,'active');
    ck(v,37,0,currVal_12);
    const currVal_15:any = ck(v,56,0,'/requests');
    ck(v,55,0,currVal_15);
    const currVal_16:any = ck(v,60,0,'active');
    ck(v,57,0,currVal_16);
    const currVal_20:any = ck(v,75,0,'/settings');
    ck(v,74,0,currVal_20);
    const currVal_21:any = ck(v,79,0,'active');
    ck(v,76,0,currVal_21);
    const currVal_24:any = ck(v,88,0,'/help');
    ck(v,87,0,currVal_24);
    const currVal_25:any = ck(v,92,0,'active');
    ck(v,89,0,currVal_25);
  },(ck,v) => {
    var co:import4.NavigationLayoutComponent = v.component;
    const currVal_0:any = (co.authService.userLoginType === 'approver');
    ck(v,7,0,currVal_0);
    const currVal_1:any = import1.ɵnov(v,9).target;
    const currVal_2:any = import1.ɵnov(v,9).href;
    ck(v,8,0,currVal_1,currVal_2);
    const currVal_5:any = import1.ɵnov(v,22).target;
    const currVal_6:any = import1.ɵnov(v,22).href;
    ck(v,21,0,currVal_5,currVal_6);
    const currVal_9:any = import1.ɵnov(v,35).target;
    const currVal_10:any = import1.ɵnov(v,35).href;
    ck(v,34,0,currVal_9,currVal_10);
    const currVal_13:any = import1.ɵnov(v,55).target;
    const currVal_14:any = import1.ɵnov(v,55).href;
    ck(v,54,0,currVal_13,currVal_14);
    const currVal_17:any = (co.authService.userLoginType === 'admin');
    ck(v,72,0,currVal_17);
    const currVal_18:any = import1.ɵnov(v,74).target;
    const currVal_19:any = import1.ɵnov(v,74).href;
    ck(v,73,0,currVal_18,currVal_19);
    const currVal_22:any = import1.ɵnov(v,87).target;
    const currVal_23:any = import1.ɵnov(v,87).href;
    ck(v,86,0,currVal_22,currVal_23);
    const currVal_26:boolean = !co.authService.loggedin;
    ck(v,99,0,currVal_26);
  });
}
function View_NavigationLayoutComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-navigation-layout',([] as any[]),(null as any),(null as any),(null as any),View_NavigationLayoutComponent_0,RenderType_NavigationLayoutComponent)),
    import1.ɵdid(57344,(null as any),0,import4.NavigationLayoutComponent,[
      import5.AuthService,
      import3.Location,
      import2.Router,
      import6.WindowRefService,
      import7.UserService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NavigationLayoutComponentNgFactory:import1.ComponentFactory<import4.NavigationLayoutComponent> = import1.ɵccf('my-navigation-layout',import4.NavigationLayoutComponent,View_NavigationLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/layout/navigation.component.ngfactory.ts